import * as React from 'react';
import { SvgIcon } from '../SvgIcon';

interface IProps extends React.SVGProps<SVGSVGElement> {
	fillColor?: string;
}

export const ApproveMarkIcon = (props: IProps) => {
	const height = 15;
	const width = 16;
	return (
		<SvgIcon
			className='approve-mark-icon'
			fill='none'
			height={height}
			viewBox={`0 0 ${width} ${height}`}
			width={width}
			{...props}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M7 15c-3.859 0-7-3.14-7-7s3.141-7 7-7v1.556A5.45 5.45 0 0 0 1.556 8 5.45 5.45 0 0 0 7 13.444 5.45 5.45 0 0 0 12.445 8H14c0 3.86-3.141 7-7 7'
				fill='currentColor'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M8.022 11 4 6.99l1.43-1.424 2.442 2.436L14.438 0 16 1.275 8.022 11Z'
				fill='currentColor'
			/>
		</SvgIcon>
	);
};
